export default __webpack_public_path__ + "static/media/Punto_04_Quartiere_Venezia_DEU_Def.fe3e49d0.aac";